import { baseApi } from './baseApi.service';
import { Endpoint } from './config/apiTags';

export interface GetReportDataRequest {
  table: string;
  filters: {
    field: string;
    operator: string;
    value: string;
  }[];
  limit?: number;
  offset?: number;
  orderBy?: string;
  orderDirection?: 'asc' | 'desc';
}

export interface GetReportDataResponse {
  data: any[];
  count: number;
}

export const reportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReportData: builder.query<GetReportDataResponse, GetReportDataRequest>({
      query: (params) => ({
        url: Endpoint.GET_REPORT_DATA,
        method: 'POST',
        body: params,
      }),
    }),
  }),
});

export const { useLazyGetReportDataQuery } = reportApi; 